import React, { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Header from './organisms/Header/Header'
import MobileHeader from './organisms/MobileHeader/MobileHeader';

const Layout = () => {
  const location = useLocation();
  const [ismobile, setIsmobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  return (
    <div className='relative'>
      <div className={`absolute top-0 z-50 w-full ${ismobile ? '' : 'p-[_3%_6%]'}`}>
        {!ismobile ? <Header /> : <MobileHeader />}
      </div>
      <Outlet />
    </div>
  )
}

export default Layout
